import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// external url https://stackblitz.com/edit/angular-external-links?file=src%2Fapp%2Frouting.module.ts
// const externalUrlProvider = new InjectionToken('externalUrlRedirectResolver');

const routes: Routes = [
  {
    path: 'app',
    loadChildren: () => import('./app-layouts/base-layout/base-layout.module').then((m) => m.BaseLayoutModule),
  },
  {
    path: 'sys',
    loadChildren: () => import('./app-layouts/system-layout/system-layout.module').then((m) => m.SystemLayoutModule),
  },
  {
    path: 'dbs',
    loadChildren: () => import('./app-layouts/datadb-layout/datadb-layout.module').then((m) => m.DatadbLayoutModule),
  },
  {
    path: 'chk',
    loadChildren: () => import('./app-layouts/checks-layout/checks-layout.module').then((m) => m.ChecksLayoutModule),
  },
  {
    path: 'tik',
    loadChildren: () => import('./app-layouts/tickets-layout/tickets-layout.module').then((m) => m.TicketsLayoutModule),
  },
  {
    path: 'mag',
    loadChildren: () => import('./app-layouts/magart-layout/magart-layout.module').then((m) => m.MagartLayoutModule),
  },
  { path: 'login', redirectTo: 'auth/login', pathMatch: 'prefix' },
  {
    path: 'cpass',
    redirectTo: 'auth/cpass',
  },
  {
    path: 'auth',
    loadChildren: () => import('./auth/autenticazione.module').then((m) => m.AutenticazioneModule),
  },

  { path: 'home', redirectTo: 'app/home', pathMatch: 'full' },
  { path: '', redirectTo: 'app/home', pathMatch: 'full' },
  {
    path: 'test',
    loadChildren: () => import('./_test/test.module').then((m) => m.TestModule),
  },
  /*
    {
      path: 'app1',
      loadChildren: '../../projects/base/src/app/app.module#AppBaseSharedModule'
    },
    {
      path: 'app2',
      loadChildren: '.. /../projects/chkl/src/app/app.module#AppChklSharedModule '
    },*/
  /* { path: ' ** ', redirectTo: ' / app1 / one ' },

   // otherwise redirect to home
   { path: '**', redirectTo: '' }*/
  /* per 404 = /err/404 */
  {
    path: 'err',
    loadChildren: () => import('./_components/error-pages/errors-pages.module').then((m) => m.ErrorPagesModule),
  },

  {
    path: '**',
    loadChildren: () => import('./_components/error-pages/errors-pages.module').then((m) => m.ErrorPagesModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
// export const routingComponents = [PageErr0Component, PageErr404Component];
